export var MANAGER_ASSIGNMENT_SCOPE;
(function (MANAGER_ASSIGNMENT_SCOPE) {
    /** Access to all cases under the respondent */
    MANAGER_ASSIGNMENT_SCOPE["RESPONDENT"] = "RESPONDENT";
    /** Access restricted to a specific cases */
    MANAGER_ASSIGNMENT_SCOPE["CASE"] = "CASE";
})(MANAGER_ASSIGNMENT_SCOPE || (MANAGER_ASSIGNMENT_SCOPE = {}));
export var CASE_MANAGERS_ASSIGNMENT_TYPE;
(function (CASE_MANAGERS_ASSIGNMENT_TYPE) {
    CASE_MANAGERS_ASSIGNMENT_TYPE["PRIMARY"] = "PRIMARY";
    CASE_MANAGERS_ASSIGNMENT_TYPE["SECONDARY"] = "SECONDARY";
})(CASE_MANAGERS_ASSIGNMENT_TYPE || (CASE_MANAGERS_ASSIGNMENT_TYPE = {}));
//# sourceMappingURL=manager.js.map